import React, { useState } from 'react';
import { Modal } from '../common/Modal';
import { Clock, Save } from 'lucide-react';
import { EstimatedTime } from '../../types/movement';
import { useMovementStore } from '../../stores/movementStore';
import toast from 'react-hot-toast';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const EstimatedTimesModal = ({ isOpen, onClose }: Props) => {
  const { estimatedTimes, updateEstimatedTimes } = useMovementStore();
  const [times, setTimes] = useState<EstimatedTime[]>(estimatedTimes);

  const handleSave = async () => {
    try {
      await updateEstimatedTimes(times);
      toast.success('تم حفظ الأوقات التقديرية بنجاح');
      onClose();
    } catch (error) {
      toast.error('فشل في حفظ الأوقات التقديرية');
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} title="الأوقات التقديرية للتحركات">
      <div className="space-y-6">
        <div className="flex items-center gap-2 text-primary-600">
          <Clock size={20} />
          <span className="font-medium">تعديل الأوقات التقديرية للتحركات</span>
        </div>

        <div className="overflow-x-auto">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">من</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">إلى</th>
                <th className="px-6 py-3 text-right text-sm font-medium text-gray-500">الوقت المقدر (بالساعات)</th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {times.map((time, index) => (
                <tr key={time.id}>
                  <td className="px-6 py-4">{time.from}</td>
                  <td className="px-6 py-4">{time.to}</td>
                  <td className="px-6 py-4">
                    <input
                      type="number"
                      value={time.hours}
                      onChange={(e) => {
                        const newTimes = [...times];
                        newTimes[index] = {
                          ...time,
                          hours: Number(e.target.value)
                        };
                        setTimes(newTimes);
                      }}
                      min="0"
                      step="0.5"
                      className="w-20 px-2 py-1 border rounded-lg text-right focus:ring-2 focus:ring-primary-500"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="px-4 py-2 text-gray-600 hover:text-gray-800"
          >
            إلغاء
          </button>
          <button
            onClick={handleSave}
            className="flex items-center gap-2 px-6 py-2 bg-primary-500 text-white rounded-lg 
                     hover:bg-primary-600 transition-colors"
          >
            <Save size={18} />
            <span>حفظ التغييرات</span>
          </button>
        </div>
      </div>
    </Modal>
  );
};
